export default () => ({
  isPasswordError: false,
  credentials: {
    current_password: null
  },
  userType: null
})



// WEBPACK FOOTER //
// ./src/app/settings/profile/components/disabled-account/resources/data.js